import React, { useEffect, useState } from "react";


import { useUserDetails } from "../../../../../redux/hooks/UserDetails";
import { useTheme } from "../../../../../redux/hooks/useTheme";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import DisplayPricingPlan from "../../SubComponents/displayPricngPlan";
import Header from "../Header";
import Footer from "../Footer";

const UserPlanInfo = () => {
  const { userDetail } = useUserDetails();
  const { theme } = useTheme();
  const [isLoading, setIsLoading] = useState(true);
  const [showPlans, setShowPlans] = useState(true);
  const [billingPeriod, setBillingPeriod] = useState<'monthly' | 'yearly'>('monthly');
  const navigate = useNavigate();
  const location = useLocation();
  const handleBillingPeriodChange = (period: 'monthly' | 'yearly') => {
    setBillingPeriod(period);
  };
  useEffect(() => {
    if (userDetail && Object.keys(userDetail).length > 0) {
      setIsLoading(false); // Stop loading when `userDetail` is populated
    }
  }, [userDetail]);
  // Extract data from userDetail
  const {
    email = "N/A",
    name = "N/A",
    ogCompanyName = "N/A",
    extraCreditId = {},
    ogSubscriptionId = {},
    customDomainLimit = false,
    inLineEditorLimit = false,
    customEnhanceLimit = 0,
    customUploadImageLimit = 0,
    totalAppsCreated = 0,
    totalLeadsCreated = 0,
  } = userDetail || {};

  const { planName = "N/A", features = [] } = ogSubscriptionId;
  const { display_Plan_name = "N/A", dailyChatLimit = 0, monthlyChatLimit = 0, totalAppsCount = 0,
    totalLeadsCount = 0, uploadImageLimit = 0, enhanceMagicLimit = 0,
    monthlyPlan , price = 0 } = ogSubscriptionId;

  // Set billing period based on user's current plan
  useEffect(() => {
    console.log('monthlyPlan value:', monthlyPlan);
    if (monthlyPlan !== undefined) {
      const newBillingPeriod = monthlyPlan ? 'monthly' : 'yearly';
      console.log('Setting billing period to:', newBillingPeriod);
      setBillingPeriod(newBillingPeriod);
    }
  }, [monthlyPlan]);

  const { extraCreditCustomEnhanceLimit = 0, extraCreditCustomUploadImageLimit = 0, extraCreditDailyChatLimit = 0, extraCreditMonthlyChatLimit = 0, extraCreditTotalAppsCount = 0, extraCreditTotalLeadsCount = 0 } = extraCreditId

  const additionalFeatures = [
    { name: 'Unlimited chats with AI', limited: planName !== 'Premium' },
    { name: 'Access to pre-made tools', limited: planName !== 'Premium' },
    { name: 'Upload images directly in chat', limited: planName === 'Basic' },
    { name: 'Enhanced user interface customization', limited: planName === 'Basic' },
    { name: 'Ability to host applications', limited: planName !== 'Premium' },
    { name: 'Embed applications seamlessly into web pages', limited: planName === 'Basic' },
  ];


  // const handleBack = () => {
  //   if (window.history.length > 2) {
  //     navigate(-1);
  //   } else {
  //     // Default to home or another fallback route
  //     navigate("/");
  //   }
  // };

  const formatDate = (dateString: string): string => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "N/A";

    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    const getOrdinalSuffix = (d: number): string => {
      if (d > 3 && d < 21) return "th";
      switch (d % 10) {
        case 1: return "st";
        case 2: return "nd";
        case 3: return "rd";
        default: return "th";
      }
    };

    return `${month} ${day}${getOrdinalSuffix(day)} ${year}`;
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <img
          src="https://dlvkyia8i4zmz.cloudfront.net/r3tQgGlrTJmcKpUvZ5Kk_loader.svg"
          alt="main loader"
        />
      </div>
    );
  }

  return (
   <> 
        <Header  noPadding={true} addBottomBorder={true} isDifferentStyle={true} paddingTop={true} hideBorder paddingX={true} paddingY={true}  />
        <div  className="userprofile-bg">
            <div className="mx-auto px-[10px] billing billing-pd pb-[40px]">
                <div className="flex flex-col md:flex-row gap-[16px] tab-flex">
                    <Sidebar/>
                    <div className="flex-1 pt-[7px] userplan-right">
                      
                        <div style={{ borderRadius:'14px'}} className="plan-container-sub pt-[20px]">
                            <h2
                                className="mb-[14px] text-[20px] billing-h mb-4 leading-[28px] sm:leading-[30px] md:leading-[32px] lg:leading-[33px]" 
                                style={{ color: theme.viewMoreHeading, fontWeight:600 }}
                            >
                                Subscription
                            </h2>

                {/* Plan Section */}
                <div
                  style={{ background: theme.planSection }}
                  className="rounded-[14px] border sidebar-bordre p-[24px] sm:px-6"
                >
                  <div className="rounded-[14px] text-white">
                    <div
                      style={{ borderColor: theme.viewPlanBorderIn }}
                      className="flex flex-wrap justify-between border-b items-center pb-6"
                    >
                      <div style={{justifyContent:'space-between'}} className="flex w-full">
                       <div>
                         <p
                          style={{ color: theme.planTags }}
                          className="text-sm sm:text-base font-normal"
                        >
                          Plan
                        </p>
                        <p
                          style={{ color: theme.planBackButton }}
                          className="capitalize text-lg sm:text-xl font-medium"
                        >
                          {display_Plan_name} {planName !== "free_y" && planName !== "noPlan_m" && <span className="font-normal text-sm" style={{color:theme.viewMoreSubHeading}}>{monthlyPlan ? '(Monthly)' : '(Yearly)'}</span>}
                        </p>
                       </div>
                       {planName !== "free_y" && planName !== "noPlan_m" && (
                       <div>
                         <p
                          style={{ color: theme.planTags }}
                          className="text-sm sm:text-base font-normal"
                        >
                          Plan Price
                        </p>
                        <p
                          style={{ color: theme.planBackButton }}
                          className="capitalize text-lg sm:text-xl font-medium"
                        >
                          {price}$ {planName !== "free_y" && planName !== "noPlan_m" && <span className="font-normal text-sm" style={{color:theme.viewMoreSubHeading}}>{monthlyPlan ? '/ Month' : '/ Year'}</span>}
                        </p>
                       </div>
                       )}
                       {planName !== "noPlan_m" && (
                       <div>
                         <p
                          style={{ color: theme.planTags }}
                          className="text-sm sm:text-base font-normal"
                        >
                          Plan Period
                        </p>
                        <p
                          style={{ color: theme.planBackButton }}
                          className="capitalize text-lg sm:text-xl font-medium"
                        >
                            {planName === "free_y" ? (
                            // For free plan, use the new trialSubscription fields for trial period
                            userDetail?.trialSubscription?.trial?.startDate ? (
                              `${formatDate(userDetail.trialSubscription.trial.startDate)} - ${formatDate(userDetail.trialSubscription.trial.endDate)}`
                            ) : (
                              "N/A"
                            )
                          ) : (
                            userDetail?.subscriptionId?.billing?.subscription?.start ? (
                              `${formatDate(userDetail.subscriptionId.billing.subscription.start)} - ${formatDate(userDetail.subscriptionId.billing.subscription.end)}`
                            ) : (
                              "N/A"
                            )
                          )}
                        </p>
                       </div>
                       )}
                      </div>


                    </div>
                  </div>

                  {/* Usage Section */}
                   
                    <div
                      style={{ borderColor: theme.viewPlanBorderIn }}
                      className="pt-6"
                    >
                      {/* <h2
                                    style={{ color: theme.planBackButton }}
                                    className="text-lg sm:text-xl font-semibold mb-4"
                                    >
                                    Usage
                                    </h2> */}
 {/* provide live tools count here  */}
                      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                        {/* Total Tools */}
                        <div style={{ backgroundColor: theme.usageSection }} className="rounded-lg p-4">
                          <div className="flex justify-between">
                            <p style={{ color: theme.planTags }} className="text-sm">
                              Total Tools
                            </p>
                            <div className="relative flex items-center">
                              {/* This wrapper is the group */}
                              <div className="relative group  inline-block">
                                <svg
                                  width="16"
                                  height="17"
                                  viewBox="0 0 16 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="w-4 h-4 cursor-pointer"

                                >
                                  {/* <title></title> */}
                                  <path
                                    d="M8.00964 1.84155C4.33235 1.84155 1.35132 4.82259 1.35132 8.49988C1.35132 12.1772 4.33235 15.1582 8.00964 15.1582C11.6869 15.1582 14.668 12.1772 14.668 8.49988C14.668 4.82259 11.6869 1.84155 8.00964 1.84155Z"
                                    stroke="currentColor"
                                    strokeWidth="1.3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path d="M8.00977 11.1633V8.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                  <path d="M8.00977 5.83667H8.00227" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <div className="absolute top-full right-0 mt-2 w-64 bg-black text-white text-xs px-3 py-2 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 whitespace-normal break-words pointer-events-none">
                                  This is the total number of tools you can create and use in your account. Extra credit increases your tool limit.
                                </div>
                              </div></div></div>
                          <p style={{ color: theme.count }} className="text-2xl font-medium">
                            {totalAppsCreated} / {totalAppsCount === -1 ? 'Unlimited' : totalAppsCount + (extraCreditTotalAppsCount > 0 ? extraCreditTotalAppsCount : 0)}
                          </p>
                          {totalAppsCount !== -1 && extraCreditTotalAppsCount > 0 && (
                            <p style={{ color: theme.extraCredit }} className="text-sm mt-2">
                              Extra Credit for Total Tools: {extraCreditTotalAppsCount}
                            </p>
                          )}
                        </div>

                        {/* Total Leads */}
                        <div style={{ backgroundColor: theme.usageSection }} className="rounded-lg p-4">
                          <div className="flex justify-between">
                            <p style={{ color: theme.planTags }} className="text-sm">Total Leads</p>
                            <div className="relative flex items-center">
                              {/* Wrap both svg and tooltip in a group */}
                              <div className="relative group inline-block">
                                <svg
                                  width="16"
                                  height="17"
                                  viewBox="0 0 16 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="w-4 h-4 cursor-pointer"
                                >
                                  <path
                                    d="M8.00964 1.84155C4.33235 1.84155 1.35132 4.82259 1.35132 8.49988C1.35132 12.1772 4.33235 15.1582 8.00964 15.1582C11.6869 15.1582 14.668 12.1772 14.668 8.49988C14.668 4.82259 11.6869 1.84155 8.00964 1.84155Z"
                                    stroke="currentColor"
                                    strokeWidth="1.3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path d="M8.00977 11.1633V8.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                  <path d="M8.00977 5.83667H8.00227" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>

                                {/* Tooltip only appears when svg is hovered */}
                                <div className="absolute top-full right-0 mt-2 w-64 bg-black text-white text-xs px-3 py-2 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 whitespace-normal break-words pointer-events-none">
                                  This is the total number of leads you can collect with your account. Extra credit increases your leads limit.
                                </div>
                              </div>
                            </div>
                          </div>

                          <p style={{ color: theme.count }} className="text-2xl font-medium">
                            {totalLeadsCreated} / {totalLeadsCount === -1 ? 'Unlimited' : totalLeadsCount + (extraCreditTotalLeadsCount > 0 ? extraCreditTotalLeadsCount : 0)}
                          </p>

                          {totalLeadsCount !== -1 && extraCreditTotalLeadsCount > 0 && (
                            <p style={{ color: theme.extraCredit }} className="text-sm mt-2">
                              Extra Credit for Total Leads: {extraCreditTotalLeadsCount}
                            </p>
                          )}
                        </div>

                        {/* dailyChatLimit */}
                        {planName === "free_y" && (
                          <div style={{ backgroundColor: theme.usageSection }} className="rounded-lg p-4">
                            <div className="flex justify-between">
                              <p style={{ color: theme.planTags }} className="text-sm">
                                Daily Chat Limit
                              </p>
                              <div className="relative flex items-center">
                                {/* This wrapper is the group */}
                                <div className="relative group inline-block">
                                  <svg
                                    width="16"
                                    height="17"
                                    viewBox="0 0 16 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="w-4 h-4"
                                    style={{ cursor: 'pointer' }}
                                  >
                                    {/* <title></title> */}
                                    <path
                                      d="M8.00964 1.84155C4.33235 1.84155 1.35132 4.82259 1.35132 8.49988C1.35132 12.1772 4.33235 15.1582 8.00964 15.1582C11.6869 15.1582 14.668 12.1772 14.668 8.49988C14.668 4.82259 11.6869 1.84155 8.00964 1.84155Z"
                                      stroke="currentColor"
                                      strokeWidth="1.3"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path d="M8.00977 11.1633V8.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M8.00977 5.83667H8.00227" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                  </svg>
                                  <div className="absolute top-full right-0 mt-2 w-64 bg-black text-white text-xs px-3 py-2 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 whitespace-normal break-words pointer-events-none">
                                    This is the maximum number of chats you can have per day. Extra credit increases your daily chat limit.                                </div>
                                </div></div></div>
                            <p style={{ color: theme.count }} className="text-2xl font-medium">
                              {dailyChatLimit + (extraCreditDailyChatLimit > 0 ? extraCreditDailyChatLimit : 0)}
                            </p>
                            {extraCreditDailyChatLimit > 0 && (
                              <p style={{ color: theme.extraCredit }} className="text-sm mt-2">
                                Extra Credit for Total DailyChats: {extraCreditDailyChatLimit}
                              </p>
                            )}
                          </div>
                        )}

                        {/* monthely chat limit */}
                        <div style={{ backgroundColor: theme.usageSection }} className="rounded-lg p-4">
                          <div className="flex justify-between">
                            <p style={{ color: theme.planTags }} className="text-sm">
                              Chat Limit
                            </p>
                            <div className="relative flex items-center">
                              {/* This wrapper is the group */}
                              <div className="relative group inline-block">
                                <svg
                                  width="16"
                                  height="17"
                                  viewBox="0 0 16 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="w-4 h-4"
                                  style={{ cursor: 'pointer' }}
                                >
                                  {/* <title></title> */}
                                  <path
                                    d="M8.00964 1.84155C4.33235 1.84155 1.35132 4.82259 1.35132 8.49988C1.35132 12.1772 4.33235 15.1582 8.00964 15.1582C11.6869 15.1582 14.668 12.1772 14.668 8.49988C14.668 4.82259 11.6869 1.84155 8.00964 1.84155Z"
                                    stroke="currentColor"
                                    strokeWidth="1.3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path d="M8.00977 11.1633V8.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                  <path d="M8.00977 5.83667H8.00227" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <div className="absolute top-full right-0 mt-2 w-64 bg-black text-white text-xs px-3 py-2 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 whitespace-normal break-words pointer-events-none">
                                  This is the maximum number of chats you can have per month. Extra credit increases your monthly chat limit.        </div>
                              </div>
                            </div>
                          </div>
                          <p style={{ color: theme.count }} className="text-2xl font-medium">
                            {monthlyChatLimit + (extraCreditMonthlyChatLimit > 0 ? extraCreditMonthlyChatLimit : 0)}<span className="text-sm per-m font-inter">/Month</span>
                          </p>
                          {extraCreditMonthlyChatLimit > 0 && (
                            <p style={{ color: theme.extraCredit }} className="text-sm mt-2">
                              Extra Credit for Total MonthlyChats: {extraCreditMonthlyChatLimit}
                            </p>
                          )}
                        </div>
                        {/* CUSTOM DOMAIN limit */}
                        {/* <div style={{ backgroundColor: theme.usageSection }} className="rounded-lg p-4">
                                            <div className="flex justify-between">
                                                <p style={{ color: theme.planTags }} className="text-sm">
                                                    CUSTOM DOMAIN
                                                </p>
                                                <span className="flex items-center">
                                                    <svg
                                                    width="16"
                                                    height="17"
                                                    viewBox="0 0 16 17"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="w-4 h-4"
                                                    style={{ cursor: 'pointer' }}
                                                    >
                                                    <title>Indicates whether you have access to the custom domain feature. </title>
                                                    <path
                                                        d="M8.00964 1.84155C4.33235 1.84155 1.35132 4.82259 1.35132 8.49988C1.35132 12.1772 4.33235 15.1582 8.00964 15.1582C11.6869 15.1582 14.668 12.1772 14.668 8.49988C14.668 4.82259 11.6869 1.84155 8.00964 1.84155Z"
                                                        stroke="currentColor"
                                                        strokeWidth="1.3"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path d="M8.00977 11.1633V8.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M8.00977 5.83667H8.00227" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </span>
                                            </div>
                                            <p style={{ color: theme.count }} className="text-2xl font-medium">
                                            {customDomainLimit ? "Yes" : "No"}
                                            </p>
                                      </div> */}

                        {/* INLINE EDITOR limit */}
                        <div style={{ backgroundColor: theme.usageSection }} className="rounded-lg p-4">
                          <div className="flex justify-between">
                            <p style={{ color: theme.planTags }} className="text-sm">
                              Inline Editor
                            </p>
                            <div className="relative flex items-center">
                              {/* This wrapper is the group */}
                              <div className="relative group inline-block">
                                <svg
                                  width="16"
                                  height="17"
                                  viewBox="0 0 16 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="w-4 h-4"
                                  style={{ cursor: 'pointer' }}
                                >
                                  {/* <title>
                                </title> */}
                                  <path
                                    d="M8.00964 1.84155C4.33235 1.84155 1.35132 4.82259 1.35132 8.49988C1.35132 12.1772 4.33235 15.1582 8.00964 15.1582C11.6869 15.1582 14.668 12.1772 14.668 8.49988C14.668 4.82259 11.6869 1.84155 8.00964 1.84155Z"
                                    stroke="currentColor"
                                    strokeWidth="1.3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path d="M8.00977 11.1633V8.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                  <path d="M8.00977 5.83667H8.00227" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <p className="absolute top-full right-0 mt-2 w-64 bg-black text-white text-xs px-3 py-2 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 whitespace-normal break-words pointer-events-none">
                                  Indicates whether you have access to the inline editor feature.
                                </p>
                              </div>
                            </div>
                          </div>
                          <p style={{ color: theme.count }} className="text-2xl font-medium">
                            {inLineEditorLimit ? "Yes" : "No"}
                          </p>
                        </div>
                        {/* enhance Magic limit */}
                        <div style={{ backgroundColor: theme.usageSection }} className="rounded-lg p-4">
                          <div className="flex justify-between">
                            <p style={{ color: theme.planTags }} className="text-sm">
                              Enhance Magic Limit
                            </p>
                            <div className="relative flex items-center">
                              {/* This wrapper is the group */}
                              <div className="relative group inline-block">
                                <svg
                                  width="16"
                                  height="17"
                                  viewBox="0 0 16 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="w-4 h-4"
                                  style={{ cursor: 'pointer' }}
                                >
                                  {/* <title> </title> */}
                                  <path
                                    d="M8.00964 1.84155C4.33235 1.84155 1.35132 4.82259 1.35132 8.49988C1.35132 12.1772 4.33235 15.1582 8.00964 15.1582C11.6869 15.1582 14.668 12.1772 14.668 8.49988C14.668 4.82259 11.6869 1.84155 8.00964 1.84155Z"
                                    stroke="currentColor"
                                    strokeWidth="1.3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path d="M8.00977 11.1633V8.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                  <path d="M8.00977 5.83667H8.00227" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <div className="absolute top-full right-0 mt-2 w-64 bg-black text-white text-xs px-3 py-2 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 whitespace-normal break-words pointer-events-none">
                                  This is the maximum number of times you can use the Enhance Magic feature per tool. Extra credit increases this limit.
                                </div>
                              </div>
                            </div>
                          </div>
                          <p style={{ color: theme.count }} className="text-2xl font-medium">
                            {enhanceMagicLimit + (extraCreditCustomEnhanceLimit > 0 ? extraCreditCustomEnhanceLimit : 0)}<span className="text-sm per-m font-inter">/Tool</span>
                          </p>
                          {extraCreditCustomEnhanceLimit > 0 && (
                            <p style={{ color: theme.extraCredit }} className="text-sm mt-2">
                              Extra Credit for Enhance Magic per Tool: {extraCreditCustomEnhanceLimit}
                            </p>
                          )}
                        </div>

                        {/* upload image limit */}
                        <div style={{ backgroundColor: theme.usageSection }} className="rounded-lg p-4">
                          <div className="flex justify-between">
                            <p style={{ color: theme.planTags }} className="text-sm">
                              Upload Image Limit
                            </p>
                            <div className="relative flex items-center">
                              {/* This wrapper is the group */}
                              <div className="relative group inline-block">
                                <svg
                                  width="16"
                                  height="17"
                                  viewBox="0 0 16 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="w-4 h-4"
                                  style={{ cursor: 'pointer' }}
                                >
                                  {/* <title> </title> */}
                                  <path
                                    d="M8.00964 1.84155C4.33235 1.84155 1.35132 4.82259 1.35132 8.49988C1.35132 12.1772 4.33235 15.1582 8.00964 15.1582C11.6869 15.1582 14.668 12.1772 14.668 8.49988C14.668 4.82259 11.6869 1.84155 8.00964 1.84155Z"
                                    stroke="currentColor"
                                    strokeWidth="1.3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path d="M8.00977 11.1633V8.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                  <path d="M8.00977 5.83667H8.00227" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <div className="absolute top-full right-0 mt-2 w-64 bg-black text-white text-xs px-3 py-2 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 whitespace-normal break-words pointer-events-none">
                                  This is the maximum number of images you can upload per tool. Extra credit increases this limit.
                                </div>
                              </div>
                            </div>
                          </div>
                          <p style={{ color: theme.count }} className="text-2xl font-medium">
                            {uploadImageLimit + (extraCreditCustomUploadImageLimit > 0 ? extraCreditCustomUploadImageLimit : 0)}<span className="text-sm per-m font-inter">/Tool</span>
                          </p>
                          {extraCreditCustomUploadImageLimit > 0 && (
                            <p style={{ color: theme.extraCredit }} className="text-sm mt-2">
                              Extra Credit for Upload Image per Tool: {extraCreditCustomUploadImageLimit}
                            </p>
                          )}
                        </div>

                        {/* Features */}
                        {/* {features.length > 0 ? (
                                        features.map((feature:any, index:any) => (
                                        <div key={index} style={{ backgroundColor: theme.usageSection }} className="rounded-lg p-4">
                                            <div className="flex justify-between">
                                            <p style={{ color: theme.planTags }} className="text-sm">{feature.name}</p>
                                            <span className="flex items-center">
                                                <svg
                                                width="16"
                                                height="17"
                                                viewBox="0 0 16 17"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="w-4 h-4"
                                                >
                                                <path
                                                    d="M8.00964 1.84155C4.33235 1.84155 1.35132 4.82259 1.35132 8.49988C1.35132 12.1772 4.33235 15.1582 8.00964 15.1582C11.6869 15.1582 14.668 12.1772 14.668 8.49988C14.668 4.82259 11.6869 1.84155 8.00964 1.84155Z"
                                                    stroke="currentColor"
                                                    strokeWidth="1.3"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path d="M8.00977 11.1633V8.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M8.00977 5.83667H8.00227" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </span>
                                            </div>
                                            <p style={{ color: theme.count }} className="text-2xl font-medium">
                                            {feature._id === 'enhance_magic' && extraCreditCustomEnhanceLimit > 0
                                                ? feature.limit + extraCreditCustomEnhanceLimit
                                                : feature._id === 'upload_image' && extraCreditCustomUploadImageLimit > 0
                                                ? feature.limit + extraCreditCustomUploadImageLimit
                                                : feature.limit}
                                            </p>
                                            {feature._id === 'enhance_magic' && extraCreditCustomEnhanceLimit > 0 && (
                                            <p style={{ color: theme.extraCredit }} className="text-sm mt-2">
                                                Extra Credit for Enhance Magic per Tool: {extraCreditCustomEnhanceLimit}
                                            </p>
                                            )}
                                            {feature._id === 'upload_image' && extraCreditCustomUploadImageLimit > 0 && (
                                            <p style={{ color: theme.extraCredit }} className="text-sm mt-2">
                                                Extra Credit for Upload Image per Tool: {extraCreditCustomUploadImageLimit}
                                            </p>
                                            )}
                                        </div>
                                        ))
                                    ) : (
                                        <div style={{ backgroundColor: theme.usageSection }} className="rounded-lg p-4 text-center">
                                        <p style={{ color: theme.planTags }} className="text-sm">No features available</p>
                                        </div>
                                    )} */}
                      </div>
                    </div>
                </div>
              </div>
              

                        {/* Available Plans Section */}
                       <div>
                       <div style={{ borderRadius:'14px', width:'100%'}} className="pt-[16px] plan-container">
                            {/* <h1 
                            className="mb-6 text-[22px] sm:text-[24px] md:text-[26px] lg:text-[28px] font-semibold leading-[28px] sm:leading-[30px] md:leading-[32px] lg:leading-[33px]" 
                            style={{ color: theme.viewMoreHeading }}
                                >
                                    Available Plans
                                </h1>
                                <DisplayPricingPlan />
                            </div> */}
                  {showPlans && (
                    <div style={{ borderRadius: '14px', width: '100%' }} className="">
                      {/* <h1 
                                            className="mb-6 text-[22px] sm:text-[24px] md:text-[26px] lg:text-[28px] font-semibold leading-[28px] sm:leading-[30px] md:leading-[32px] lg:leading-[33px]" 
                                            style={{ color: theme.viewMoreHeading }}
                                        >
                                            Available Plans
                                        </h1> */}
                      <DisplayPricingPlan onReadyChange={setShowPlans} className="w-[100%]" billingPeriod={billingPeriod} onBillingPeriodChange={handleBillingPeriodChange} />
                      {/* className="w-[100%]" */}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>

  )
}

export default UserPlanInfo;
